export default "__VITE_ASSET__CVhCKS0u__"